import React, { useState, useEffect } from 'react';
import { ref, get, push, set } from 'firebase/database';
import { database } from '../../firebase/config';
import { uploadImmagine } from '../../utils/cloudinaryUtils';
import { formattaData } from '../../utils/dateUtils';

function CaricaFotoCantiere({ dipendente, onBack }) {
  const [cantieri, setCantieri] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [cantiereId, setCantiereId] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [fotoOggi, setFotoOggi] = useState([]);
  const oggi = new Date().toISOString().split('T')[0];

  useEffect(() => {
    caricaDati();
  }, [dipendente]);

  async function caricaDati() {
    if (!dipendente) return;
    const [cantSnap, cliSnap, fotoSnap] = await Promise.all([
      get(ref(database, 'cantieri')),
      get(ref(database, 'clienti')),
      get(ref(database, 'fotoCantiere')),
    ]);
    if (cantSnap.exists()) {
      setCantieri(Object.keys(cantSnap.val()).map(k => ({ id: k, ...cantSnap.val()[k] })));
    }
    if (cliSnap.exists()) {
      setClienti(Object.keys(cliSnap.val()).map(k => ({ id: k, ...cliSnap.val()[k] })));
    }
    if (fotoSnap.exists()) {
      const tutte = Object.keys(fotoSnap.val()).map(k => ({ id: k, ...fotoSnap.val()[k] }));
      // Foto di oggi di questo dipendente
      setFotoOggi(tutte.filter(f => f.dipendenteId === dipendente.id && f.data === oggi));
    }
  }

  function getCliente(cantiereId) {
    const cantiere = cantieri.find(c => c.id === cantiereId);
    if (!cantiere) return null;
    return clienti.find(c => c.id === cantiere.clienteId);
  }

  // Quante foto ha già caricato oggi per il cantiere selezionato
  function fotoPerCantiereOggi(cId) {
    return fotoOggi.filter(f => f.cantiereId === cId).length;
  }

  function handleFileChange(e) {
    const f = e.target.files[0];
    if (!f) return;
    if (!f.type.startsWith('image/')) {
      alert('Seleziona un file immagine');
      return;
    }
    setFile(f);
    setPreview(URL.createObjectURL(f));
  }

  async function handleUpload() {
    if (!cantiereId) { alert('Seleziona un cantiere'); return; }
    if (!file) { alert('Seleziona una foto'); return; }

    // Limite: max 2 foto per cantiere per dipendente al giorno
    if (fotoPerCantiereOggi(cantiereId) >= 2) {
      alert('Hai già caricato 2 foto per questo cantiere oggi');
      return;
    }

    try {
      setUploading(true);
      const { imageUrl, publicId } = await uploadImmagine(file, 'fotoCantiere');

      const nuovaFoto = {
        dipendenteId: dipendente.id,
        cantiereId,
        data: oggi,
        imageUrl,
        publicId,
        createdAt: Date.now(),
      };

      const fotoRef = ref(database, 'fotoCantiere');
      const newRef = push(fotoRef);
      await set(newRef, nuovaFoto);

      setFile(null);
      setPreview(null);
      setCantiereId('');
      alert('Foto caricata con successo!');
      caricaDati();
    } catch (error) {
      alert('Errore upload: ' + error.message);
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        <h2><img src="/CRG_logo.png" alt="crg" style={{ width: '150px' }} /></h2>
        <div className="user-info">
          <p>{dipendente ? `${dipendente.nome} ${dipendente.cognome}` : ''}</p>
        </div>
        <button className="btn-logout" onClick={onBack}>
          ← Torna indietro
        </button>
      </div>

      <div className="main-content">
        <div className="content-header">
          <h1>📷 Carica Foto Cantiere</h1>
          <p style={{ color: '#7f8c8d', marginTop: 4 }}>
            Data: {formattaData(oggi)}
          </p>
        </div>

        <div className="content-body">

          <div className="upload-card">
            <h3>Nuova Foto</h3>

            <div className="form-group">
              <label>Cantiere <span style={{ color: 'red' }}>*</span></label>
              <select
                value={cantiereId}
                onChange={e => setCantiereId(e.target.value)}
                disabled={uploading}
              >
                <option value="">— Seleziona cantiere —</option>
                {cantieri.map(c => {
                  const cliente = getCliente(c.id);
                  const usate = fotoPerCantiereOggi(c.id);
                  return (
                    <option key={c.id} value={c.id} disabled={usate >= 2}>
                      {c.luogo} {cliente ? `(${cliente.ragioneSociale})` : ''}
                      {usate > 0 ? ` · ${usate}/2 foto` : ''}
                    </option>
                  );
                })}
              </select>
              {cantiereId && (
                <small style={{
                  color: fotoPerCantiereOggi(cantiereId) >= 2 ? '#e74c3c' : '#27ae60'
                }}>
                  {fotoPerCantiereOggi(cantiereId)}/2 foto caricate oggi per questo cantiere
                </small>
              )}
            </div>

            <div className="form-group">
              <label>Foto <span style={{ color: 'red' }}>*</span></label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                disabled={uploading}
              />
              <small style={{ color: '#888' }}>
                Max 2 foto per cantiere al giorno
              </small>
            </div>

            {preview && (
              <div className="preview-container">
                <img src={preview} alt="Anteprima" className="preview-img" />
              </div>
            )}

            <button
              onClick={handleUpload}
              disabled={uploading || !file || !cantiereId || fotoPerCantiereOggi(cantiereId) >= 2}
              className="btn-upload"
            >
              {uploading ? '⏳ Caricamento in corso...' : 'Carica Foto'}
            </button>
          </div>

          {/* Foto caricate oggi */}
          {fotoOggi.length > 0 && (
            <div className="upload-card" style={{ marginTop: 24 }}>
              <h3>Foto caricate oggi ({fotoOggi.length})</h3>
              <div className="foto-grid">
                {fotoOggi.map(f => {
                  const cantiere = cantieri.find(c => c.id === f.cantiereId);
                  const cliente = getCliente(f.cantiereId);
                  return (
                    <div key={f.id} className="foto-item">
                      <img src={f.imageUrl} alt="Foto cantiere" className="foto-thumb" />
                      <small>
                        {cantiere?.luogo || 'N/D'}
                        {cliente ? ` · ${cliente.ragioneSociale}` : ''}
                      </small>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default CaricaFotoCantiere;
